<template>
  <div class="pc">
    <img
      v-show="showImage"
      src="https://p0.ssl.qhimg.com/t11b673bcd6695c31cff9762417.png"
      alt=""
      class="pcJumpBottom"
      @click="scrollToBottom"
      draggable="false"
    />
    <div class="pcLogo">
      <img :src="imgs?.pcLogoImg" alt="" class="pcLogoImg" />
    </div>
    <img :src="imgs?.pcBanner" alt="" class="pcBanner" />
    <div class="pcOverview">
      <img :src="imgs.pcOverviewImg" alt="" class="pcOverviewImg" />
    </div>
    <div class="pcClass">
      <img :src="imgs.pcClassImg" alt="" class="pcClassImg" />
    </div>
    <div class="pcTeach">
      <img
        src="https://p2.ssl.qhimg.com/t11b673bcd62d129fcca2cd46b4.png"
        alt=""
        class="pcTeachTitle"
      />
      <div class="pcTeachContent">
        <div class="safeClass">
          <img :src="safeClass?.avtar" alt="" class="safeClassAvtar" />
          <div class="safeClassHead">
            <div class="safeClassHeadType">{{ safeClass?.className }}</div>
            <div class="safeClassHeadBox">
              <span class="safeClassHeadBoxName">{{ safeClass?.teacher }}</span>
              <div class="safeClassHeadBoxInfo">
                <img :src="safeClass?.crown" alt="" class="safeClassHeadBoxAvtar" />
                <div class="safeClassHeadBoxLevel">{{ safeClass?.teacherLevel }}</div>
              </div>
            </div>
            <div class="safeClassHeadTitle">
              {{ safeClass?.teacherTitle }}
            </div>
          </div>
          <div class="safeClassIntro">
            {{ safeClass?.intro }}
          </div>
          <div class="safeClassList">
            <div
              v-for="(item, index) in safeClass?.studentsArr"
              :key="index"
              class="safeClassListItem"
            >
              <img :src="item.avtar" alt="" class="safeClassListItemAvtar" />
              <div class="safeClassListItemBox">
                <div class="safeClassListItemBoxName">{{ item.name }}</div>
                <div class="safeClassListItemBoxIntro">{{ item.intro }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="aiClass">
          <img
            src="https://p3.ssl.qhimg.com/t11b673bcd6f672c271a2bfd8ba.png"
            alt=""
            class="aiClassAvtar"
          />
          <!-- <img :src="aiClass?.avtar" alt="" class="aiClassAvtar" /> -->
          <div class="aiClassHead">
            <div class="aiClassHeadType">{{ aiClass?.className }}</div>
            <div class="aiClassHeadBox">
              <span class="aiClassHeadBoxName">{{ aiClass?.teacher }}</span>
              <div class="aiClassHeadBoxInfo">
                <img :src="aiClass?.crown" alt="" class="aiClassHeadBoxAvtar" />
                <div class="aiClassHeadBoxLevel">{{ aiClass?.teacherLevel }}</div>
              </div>
            </div>
            <div class="aiClassHeadTitle">
              {{ aiClass?.teacherTitle }}
            </div>
          </div>
          <div class="aiClassIntro">
            {{ aiClass?.intro }}
          </div>
          <div class="aiClassList">
            <div v-for="(item, index) in aiClass?.studentsArr" :key="index" class="aiClassListItem">
              <img :src="item.avtar" alt="" class="aiClassListItemAvtar" />
              <div class="aiClassListItemBox">
                <div class="aiClassListItemBoxName">{{ item.name }}</div>
                <div class="aiClassListItemBoxIntro">{{ item.intro }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pcSignup">
      <img :src="imgs.pcSignupImg" alt="" class="pcSignupImg" />
    </div>
    <div class="pcPartner">
      <img
        src="https://p5.ssl.qhimg.com/t11b673bcd6b4464151864cd116.png"
        alt=""
        class="pcPartnerTitle"
      />
      <!-- <img :src="imgs?.pcPartner" alt="" class="pcPartnerImg"> -->
      <div class="pcPartnerBox">
        <img
          @click="jumbToPartner(item.id)"
          v-for="(item, index) in partners"
          :key="index"
          :src="item.photo"
          alt=""
          class="pcPartnerBoxItem"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, onMounted, onUnmounted } from 'vue'
import { getRecruit } from '@/api/2024/index'

let aiClass = ref({})
let safeClass = ref({})
let imgs = ref({})
const partners = ref([
  {
    photo: 'https://p2.ssl.qhimg.com/t11b673bcd65ab8a376bc83e517.png',
    id: 'snow'
  },
  {
    photo: 'https://p5.ssl.qhimg.com/t11b673bcd6d1d64ea812cf05c4.png',
    id: 'service'
  },
  {
    photo: 'https://p2.ssl.qhimg.com/t11b673bcd604d30d41cb443db4.png',
    id: 'ai'
  }
])

// let aiClass = ref({
//   className: 'AI课程',
//   teacher: '殷宇辉',
//   teacherLevel: '领衔导师',
//   teacherTitle: '360高级威胁研究院高级工程师',
//   avtar: 'https://p5.ssl.qhimg.com/t11b673bcd6cbd549f81e8a89eb.png',
//   crown: 'https://p4.ssl.qhimg.com/t11b673bcd635bec9e5ab95d33d.png',
//   intro:
//     'APT技术分析负责人，带领团队捕获多个APT攻击组织和在野0day漏洞，同时作为主要作者研发了360恶意程序自动化分析系统，以及作为核心人员参与360国产自主杀毒引擎国际评测并满分夺冠。',
//   studentsArr: [
//     {
//       name: '应之龙',
//       avtar: 'https://p4.ssl.qhimg.com/t11b673bcd66c9e3d2fb84bd6f6.png',
//       intro: '360数智化集团大模型应用产品专家'
//     },
//     {
//       name: '宋翰轩',
//       avtar: 'https://p0.ssl.qhimg.com/t11b673bcd68fe48048d518b8d5.png',
//       intro: '360数智化集团技术中台产品战略负责人'
//     },
//     {
//       name: '高献光',
//       avtar: 'https://p5.ssl.qhimg.com/t11b673bcd68d5e169ce9f77a88.png',
//       intro: '360企业云盘产品技术总监，智能文档云首席技术架构师'
//     },
//     {
//       name: '刘俊华',
//       avtar: 'https://p3.ssl.qhimg.com/t11b673bcd6f607158ed18ff5db.png',
//       intro: '360数智化集团智能产品解决方案总监，企业级大模型解决方案负责人'
//     },
//     {
//       name: '常宝宝',
//       avtar: 'https://p2.ssl.qhimg.com/t11b673bcd692a7c08e3786e4f6.png',
//       intro: '北京大学计算机学院副教授、博士生导师'
//     },
//     {
//       name: '沙磊',
//       avtar: 'https://p0.ssl.qhimg.com/t11b673bcd6a6f4084088753f5d.png',
//       intro: '北京航空航天大学人工智能学院教授，博士生导师'
//     },
//     {
//       name: '周长江',
//       avtar: 'https://p3.ssl.qhimg.com/t11b673bcd6dda88bde850a0d25.png',
//       intro: '360技术中台产品专家、大模型开发平台产品负责人'
//     },
//     {
//       name: '张伟',
//       avtar: 'https://p5.ssl.qhimg.com/t11b673bcd63d217b3f9da97ef4.png',
//       intro: '360数智化集团大模型应用产品专家'
//     }
//   ]
// })

// let safeClass = ref({
//   className: '数字安全课程',
//   teacher: '潘剑锋',
//   teacherLevel: '领衔导师',
//   teacherTitle: '360高级威胁研究院高级工程师',
//   avtar: 'https://p5.ssl.qhimg.com/t11b673bcd6cbd549f81e8a89eb.png',
//   crown: 'https://p4.ssl.qhimg.com/t11b673bcd635bec9e5ab95d33d.png',
//   intro:
//     'APT技术分析负责人，带领团队捕获多个APT攻击组织和在野0day漏洞，同时作为主要作者研发了360恶意程序自动化分析系统，以及作为核心人员参与360国产自主杀毒引擎国际评测并满分夺冠。',
//   studentsArr: [
//     {
//       name: '应之龙',
//       avtar: 'https://p4.ssl.qhimg.com/t11b673bcd66c9e3d2fb84bd6f6.png',
//       intro: '360数智化集团大模型应用产品专家'
//     },
//     {
//       name: '宋翰轩',
//       avtar: 'https://p0.ssl.qhimg.com/t11b673bcd68fe48048d518b8d5.png',
//       intro: '360数智化集团技术中台产品战略负责人'
//     },
//     {
//       name: '高献光',
//       avtar: 'https://p5.ssl.qhimg.com/t11b673bcd68d5e169ce9f77a88.png',
//       intro: '360企业云盘产品技术总监，智能文档云首席技术架构师'
//     },
//     {
//       name: '刘俊华',
//       avtar: 'https://p3.ssl.qhimg.com/t11b673bcd6f607158ed18ff5db.png',
//       intro: '360数智化集团智能产品解决方案总监，企业级大模型解决方案负责人'
//     },
//     {
//       name: '常宝宝',
//       avtar: 'https://p2.ssl.qhimg.com/t11b673bcd692a7c08e3786e4f6.png',
//       intro: '北京大学计算机学院副教授、博士生导师'
//     },
//     {
//       name: '沙磊',
//       avtar: 'https://p0.ssl.qhimg.com/t11b673bcd6a6f4084088753f5d.png',
//       intro: '北京航空航天大学人工智能学院教授，博士生导师'
//     },
//     {
//       name: '周长江',
//       avtar: 'https://p3.ssl.qhimg.com/t11b673bcd6dda88bde850a0d25.png',
//       intro: '360技术中台产品专家、大模型开发平台产品负责人'
//     },
//     {
//       name: '张伟',
//       avtar: 'https://p5.ssl.qhimg.com/t11b673bcd63d217b3f9da97ef4.png',
//       intro: '360数智化集团大模型应用产品专家'
//     }
//   ]
// })

// let imgs = ref({
//   pcLogoImg: 'https://p5.ssl.qhimg.com/t11b673bcd6fe1255f4a83753eb.png',
//   pcBanner: 'https://p1.ssl.qhimg.com/t11b673bcd64d7a3291b772c49a.png',
//   pcOverviewImg: 'https://p4.ssl.qhimg.com/t11b673bcd6808bd6eeb17366b9.png',
//   pcClassImg: 'https://p5.ssl.qhimg.com/t11b673bcd6b6a780051c4dfe74.png',
//   pcSignupImg: 'https://p2.ssl.qhimg.com/t11b673bcd66564595b751b60ad.png',
//   pcPartner: 'https://p3.ssl.qhimg.com/t11b673bcd6b475d6203b818ff2.png',
//   mobileLogo: 'https://p0.ssl.qhimg.com/t11b673bcd6ddb1a4b59e3b3f97.png',
//   mobileBanner: 'https://p2.ssl.qhimg.com/t11b673bcd644bf8e33d6c71019.png',
//   mobileBodyOverall: 'https://p4.ssl.qhimg.com/t11b673bcd6224273d0797754c8.png',
//   mobileBodyOverallDetail: 'https://p2.ssl.qhimg.com/t11b673bcd66f290ea1a944db17.png',
//   mobileBodyClass: 'https://p5.ssl.qhimg.com/t11b673bcd6e8d6403d1dbf7d0a.png',
//   mobileBodyClassDetail: 'https://p4.ssl.qhimg.com/t11b673bcd63caaea10af59bf22.png',
//   mobileBodySignup: 'https://p2.ssl.qhimg.com/t11b673bcd6016abda5a235b4d1.png',
//   mobileQrCode: 'https://p2.ssl.qhimg.com/t11b673bcd6b42f9658c1e4506a.png',
//   mobilePartner: 'https://p0.ssl.qhimg.com/t11b673bcd6a0799cde9cfa943f.png'
// })

let lastScrollY = window.scrollY
const showImage = ref(true)

const scrollToBottom = () => {
  window.scrollTo({
    top: document.body.scrollHeight,
    behavior: 'smooth'
  })
  showImage.value = false
}

const handleScroll = () => {
  const currentScrollY = window.scrollY
  const bottomThreshold = document.documentElement.scrollHeight - window.innerHeight

  if (currentScrollY >= bottomThreshold) {
    showImage.value = false
  } else if (currentScrollY < lastScrollY) {
    showImage.value = true
  }

  lastScrollY = currentScrollY
}

const jumbToPartner = (id) => {
  if (id === 'snow') {
    window.open('https://www.kanxue.com/book-leaflet-185.htm', '_blank')
  } else if (id === 'service') {
    window.open('http://www.mydataservice.com.cn/index.html', '_blank')
  } else {
    window.open(
      'https://ai.aigongtongti.org.cn/archives/0681dd1c-305a-4d11-9caa-7d87e83fbf92',
      '_blank'
    )
  }
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
onBeforeMount(async () => {
  await fetch()
})

function fetch() {
  getRecruit('ZHdKeG1Xc1hkbjJ1d3YxZ3VlWDFuUT09OjqlcZEMpk30dFSNP9/NAE69')
    .then((res) => {
      let arr = JSON.parse(res.data.data.data)
      // console.log('res', arr)
      aiClass.value = arr[0]
      safeClass.value = arr[1]
      imgs.value = arr[2]
    })
    .catch(() => {})
}
</script>

<style lang="scss" scoped>
.pc {
  width: 100%;
  position: relative;
  &Logo {
    // width: 1170px;
    width: 993px;
    height: 77px;
    margin: 0 auto;
    &Img {
      width: 143px;
      height: 40px;
      margin-top: 20px;
    }
  }
  &Banner {
    width: 100%;
    display: block;
  }
  &Overview {
    padding: 79px 0 84px;
    &Img {
      display: block;
      margin: 0 auto;
      width: 1170px;
    }
  }
  &Class {
    padding: 60px 0 80px;
    background: rgb(246, 249, 253);
    &Img {
      display: block;
      margin: 0 auto;
      width: 1170px;
    }
  }
  &Teach {
    &Title {
      display: block;
      width: 176px;
      margin: 117px auto 0;
    }
    &Content {
      width: 1158px;
      margin: 86px auto 0;
      display: flex;
      justify-content: space-between;
      //   background-color: pink;
    }
  }
  &Signup {
    padding: 141px 0 121px;
    &Img {
      display: block;
      margin: 0 auto;
      width: 1170px;
    }
  }
  &Partner {
    margin: 0 auto 163px;
    width: 466px;
    // background-color: pink;
    &Title {
      width: 167px;
      margin: 0 auto 37px;
      display: block;
    }
    &Box {
      display: flex;
      gap: 0 8px;

      &Item {
        width: 150px;
        cursor: pointer;
      }
    }

    // background-color: pink;
    // &Img {
    //   display: block;
    //   margin: 0 auto;
    //   width: 466px;
    // }
  }
  .aiClass {
    width: 566px;
    &Head {
      width: 100%;
      height: 263px;
      background-image: url('https://p1.ssl.qhimg.com/t11b673bcd6f5db00abba93f7fd.png'); /* 设置背景图片 */
      background-size: cover;
      background-repeat: no-repeat;
      padding-top: 14px;
      &Type {
        margin: 0 0 0 53px;
        color: rgb(255, 255, 255);
        font-size: 24px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: justify;
      }
      &Box {
        margin: 62px 0 0 52px;
        height: 50px;
        display: flex;
        &Name {
          color: rgb(0, 0, 0);
          margin-right: 16px;
          margin-top: 14px;
          font-size: 36px;
          font-weight: 700;
          line-height: 36px;
          letter-spacing: 0px;
          text-align: left;
        }
        &Avtar {
          width: 31px;
          height: 27px;
          display: block;
          margin: 0 auto;
        }
        &Level {
          color: rgb(0, 0, 0);
          margin-top: 10px;
          font-size: 14px;
          font-weight: 500;
          line-height: 14px;
          letter-spacing: 0px;
          text-align: left;
        }
      }
      &Title {
      width: 240px;
        color: rgb(0, 0, 0);
        margin-top: 8px;
        margin-left: 52px;
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0px;
        text-align: left;
      }
    }
    &Avtar {
      width: 211px;
      position: absolute;
      z-index: 10;
      right: -8px;
      top: -33px;
    }
    &Intro {
      width: 520px;
      // height: 130px;
      border-radius: 12px;
      padding: 21px 23px 25px 26px;
      box-shadow: 0px 10px 25px 0px rgba(47, 184, 236, 0.15);
      background: rgb(255, 255, 255);
      color: rgb(0, 0, 0);
      font-size: 14px;
      font-weight: 400;
      line-height: 28px;
      letter-spacing: 0px;
      text-align: justify;
      position: absolute;
      left: 23px;
      top: 198px;
      z-index: 20;
    }
    &List {
      border-radius: 0px 0px 16px 16px;
      padding: 150px 23px 57px;
      background: rgb(245, 248, 251);
      display: flex;
      flex-wrap: wrap;
      gap: 25px 16px;
      &Item {
        width: 252px;
        height: 270px;
        // background-color: pink;
        &Avtar {
          width: 128px;
          display: block;
          position: absolute;
          top: 0;
          z-index: 10;
          left: 50%; /* 左边缘移动到父元素的中心 */
          transform: translateX(-50%); /* 向左移动自身宽度的50%以居中 */
        }
        &Box {
          position: absolute;
          top: 64px;
          width: 100%;
          height: 206px;
          background-image: url('https://p4.ssl.qhimg.com/t11b673bcd673d5683f3c3aec5e.png'); /* 设置背景图片 */
          background-size: cover; /* 背景图片覆盖整个div */
          background-repeat: no-repeat; /* 背景图片不重复 */
          &Name {
            margin-top: 92px;
            color: rgb(0, 0, 0);
            font-size: 20px;
            font-weight: 700;
            line-height: 20px;
            letter-spacing: 0px;
            text-align: center;
          }
          &Intro {
            margin: 20px auto 0;
            width: 168px;
            color: rgb(0, 0, 0);
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            letter-spacing: 0px;
            text-align: center;
          }
        }
      }
    }
  }
  .safeClass {
    width: 566px;
    &Head {
      width: 100%;
      height: 263px;
      background-image: url('https://p0.ssl.qhimg.com/t11b673bcd63bd3d82dd4948779.png'); /* 设置背景图片 */
      background-size: cover;
      background-repeat: no-repeat;
      padding-top: 14px;
      &Type {
        margin: 0 0 0 53px;
        color: rgb(255, 255, 255);
        font-size: 24px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: justify;
      }
      &Box {
        margin: 62px 0 0 52px;
        height: 50px;
        display: flex;
        &Name {
          color: rgb(0, 0, 0);
          margin-right: 16px;
          margin-top: 14px;
          font-size: 36px;
          font-weight: 700;
          line-height: 36px;
          letter-spacing: 0px;
          text-align: left;
        }
        &Avtar {
          width: 31px;
          height: 27px;
          display: block;
          margin: 0 auto;
        }
        &Level {
          color: rgb(0, 0, 0);
          margin-top: 10px;
          font-size: 14px;
          font-weight: 500;
          line-height: 14px;
          letter-spacing: 0px;
          text-align: left;
        }
      }
      &Title {
        color: rgb(0, 0, 0);
        margin-top: 18px;
        margin-left: 52px;
        font-size: 14px;
        font-weight: 500;
        line-height: 14px;
        letter-spacing: 0px;
        text-align: left;
      }
    }
    &Avtar {
      width: 211px;
      position: absolute;
      z-index: 10;
      right: 35px;
      top: -33px;
    }
    &Intro {
      width: 520px;
      // height: 130px;
      border-radius: 12px;
      padding: 21px 23px 25px 26px;
      box-shadow: 0px 10px 25px 0px rgba(47, 184, 236, 0.15);
      background: rgb(255, 255, 255);
      color: rgb(0, 0, 0);
      font-size: 14px;
      font-weight: 400;
      line-height: 28px;
      letter-spacing: 0px;
      text-align: justify;
      position: absolute;
      left: 23px;
      top: 198px;
      z-index: 20;
    }
    &List {
      border-radius: 0px 0px 16px 16px;
      padding: 150px 23px 57px;
      background: rgb(245, 248, 251);
      display: flex;
      flex-wrap: wrap;
      gap: 25px 16px;
      &Item {
        width: 252px;
        height: 270px;
        // background-color: pink;
        &Avtar {
          width: 128px;
          display: block;
          position: absolute;
          top: 0;
          z-index: 10;
          left: 50%; /* 左边缘移动到父元素的中心 */
          transform: translateX(-50%); /* 向左移动自身宽度的50%以居中 */
        }
        &Box {
          position: absolute;
          top: 64px;
          width: 100%;
          height: 206px;
          background-image: url('https://p4.ssl.qhimg.com/t11b673bcd6cbf218e3614b3468.png'); /* 设置背景图片 */
          background-size: cover; /* 背景图片覆盖整个div */
          background-repeat: no-repeat; /* 背景图片不重复 */
          &Name {
            margin-top: 92px;
            color: rgb(0, 0, 0);
            font-size: 20px;
            font-weight: 700;
            line-height: 20px;
            letter-spacing: 0px;
            text-align: center;
          }
          &Intro {
            margin: 20px auto 0;
            width: 168px;
            color: rgb(0, 0, 0);
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            letter-spacing: 0px;
            text-align: center;
          }
        }
      }
    }
  }
  &JumpBottom {
    position: fixed;
    right: 4%;
    top: 60%;
    width: 100px;
    height: 109px;
    z-index: 40;
    cursor: pointer;
  }
}
</style>
